<template>
  <el-dialog
    title="用户群组管理"
    :visible="visible"
    width="1000px"
    @close="handleClose"
  >
    <div class="user-group-manager">
      <!-- 用户信息 -->
      <div class="user-info-section">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="用户ID">
            {{ userData.id }}
          </el-descriptions-item>
          <el-descriptions-item label="用户昵称">
            {{ userData.nickName }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 操作区域 -->
      <div class="operation-section">
        <el-row :gutter="20">
          <el-card header="添加用户到群组">
            <el-form :model="addForm" label-width="100px">
              <el-form-item label="选择群组">
                <el-button
                  type="primary"
                  @click="showGroupSelector = !showGroupSelector"
                  style="width: 100%"
                >
                  {{
                    selectedGroups.length > 0
                      ? `已选 ${selectedGroups.length} 个群组`
                      : "点击选择群组"
                  }}
                  <i
                    :class="
                      showGroupSelector
                        ? 'el-icon-arrow-up'
                        : 'el-icon-arrow-down'
                    "
                    style="margin-left: 8px"
                  ></i>
                </el-button>
              </el-form-item>

              <!-- 群组选择区域 -->
              <el-form-item v-if="showGroupSelector">
                <div class="group-selector-inline">
                  <!-- 搜索区域 -->
                  <div class="search-section">
                    <el-input
                      v-model="groupSearchKeyword"
                      placeholder="搜索群组名称或群主"
                      prefix-icon="el-icon-search"
                      @input="handleGroupSearch"
                      clearable
                      size="small"
                    />
                  </div>

                  <!-- 群组列表 -->
                  <el-table
                    :data="filteredGroups"
                    style="width: 100%"
                    v-loading="groupsLoading"
                    ref="groupTable"
                    @selection-change="handleSelectionChange"
                    max-height="300"
                    size="small"
                  >
                    <el-table-column type="selection" width="55" />
                    <el-table-column prop="id" label="群组ID" width="80" />
                    <el-table-column prop="name" label="群组名称" />
                    <el-table-column
                      prop="ownerId"
                      label="群主ID"
                      width="100"
                    />
                    <el-table-column
                      prop="memberCount"
                      label="成员数"
                      width="80"
                    />
                    <el-table-column
                      prop="notice"
                      label="群公告"
                      show-overflow-tooltip
                    />
                    <el-table-column prop="isBanned" label="状态" width="80">
                      <template slot-scope="scope">
                        <el-tag
                          :type="scope.row.isBanned ? 'danger' : 'success'"
                          size="mini"
                        >
                          {{ scope.row.isBanned ? "已封禁" : "正常" }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </el-table>

                  <!-- 分页 -->
                  <!-- <div class="pagination-section">
                    <el-pagination
                      @current-change="handlePageChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      :total="totalGroups"
                      layout="total, prev, pager, next"
                      small
                    />
                  </div> -->
                </div>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  :loading="addLoading"
                  @click="handleAddToGroup"
                >
                  添加到群组
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-row>
      </div>

      <!-- 用户群组列表 -->
      <div class="groups-section">
        <el-card header="用户群组列表">
          <el-table
            :data="userGroups"
            style="width: 100%"
            v-loading="groupsLoading"
          >
            <el-table-column prop="id" label="群组ID" width="80" />
            <el-table-column prop="name" label="群组名称" />
            <el-table-column prop="ownerId" label="群主ID" width="100" />
            <el-table-column
              prop="notice"
              label="群公告"
              show-overflow-tooltip
            />
            <el-table-column prop="isMuted" label="全体禁言" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isMuted ? 'danger' : 'success'">
                  {{ scope.row.isMuted ? "是" : "否" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="isBanned" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isBanned ? 'danger' : 'success'">
                  {{ scope.row.isBanned ? "已封禁" : "正常" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleQuickRemove(scope.row)"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { manageUserGroup, getUserGroups } from "@/api/user";
import { getManagedGroups } from "@/api/group";

export default {
  name: "UserGroupManager",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      userGroups: [],
      availableGroups: [],
      filteredGroups: [],
      groupsLoading: false,
      addLoading: false,
      removeLoading: false,
      showGroupSelector: false,
      selectedGroups: [],
      groupSearchKeyword: "",
      currentPage: 1,
      pageSize: 10,
      totalGroups: 0,
      addForm: {
        groupIds: [],
        remarkNickName: "",
        remarkGroupName: "",
        isMuted: false,
      },
      removeForm: {
        groupId: null,
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadUserGroups();
        this.loadAvailableGroups();
        // 重置状态
        this.showGroupSelector = false;
        this.selectedGroups = [];
        this.groupSearchKeyword = "";
      }
    },
  },
  methods: {
    // 加载用户群组列表
    async loadUserGroups() {
      if (!this.userData.id) return;

      this.groupsLoading = true;
      try {
        const response = await getUserGroups(this.userData.id);
        this.userGroups = response.data || [];
      } catch (error) {
        this.$message.error("加载用户群组失败");
        console.error("Load user groups error:", error);
      } finally {
        this.groupsLoading = false;
      }
    },

    // 加载可用的群组列表
    async loadAvailableGroups() {
      this.groupsLoading = true;
      try {
        const response = await getManagedGroups({
          page: this.currentPage,
          size: this.pageSize,
          keyword: this.groupSearchKeyword,
        });
        this.availableGroups = response.data?.list || response.data || [];
        this.totalGroups = response.data?.total || this.availableGroups.length;
        this.filteredGroups = this.availableGroups;
      } catch (error) {
        this.$message.error("加载群组列表失败");
        console.error("Load groups error:", error);
      } finally {
        this.groupsLoading = false;
      }
    },

    // 群组搜索
    handleGroupSearch() {
      this.currentPage = 1;
      this.loadAvailableGroups();
    },

    // 分页处理
    handlePageChange(page) {
      this.currentPage = page;
      this.loadAvailableGroups();
    },

    // 多选变更
    handleSelectionChange(selection) {
      this.selectedGroups = selection;
    },

    // 添加用户到群组
    async handleAddToGroup() {
      if (!this.selectedGroups.length) {
        this.$message.warning("请选择至少一个群组");
        return;
      }

      this.addLoading = true;
      try {
        const results = await Promise.allSettled(
          this.selectedGroups.map((g) =>
            manageUserGroup({
              userId: this.userData.id,
              groupId: g.id,
              remarkNickName: this.addForm.remarkNickName,
              remarkGroupName: this.addForm.remarkGroupName,
              isMuted: this.addForm.isMuted,
              operationType: "ADD",
            }),
          ),
        );

        const successCount = results.filter(
          (r) => r.status === "fulfilled",
        ).length;
        const failCount = results.length - successCount;
        if (successCount > 0) {
          this.$message.success(
            `成功添加 ${successCount} 个群组${
              failCount ? `，失败 ${failCount} 个` : ""
            }`,
          );
        } else {
          this.$message.error("添加用户到群组失败");
        }

        // 重置表单
        this.addForm = {
          groupIds: [],
          remarkNickName: "",
          remarkGroupName: "",
          isMuted: false,
        };
        this.selectedGroups = [];
        this.showGroupSelector = false;

        // 重新加载用户群组列表
        this.loadUserGroups();
      } catch (error) {
        this.$message.error("添加用户到群组失败");
        console.error("Add user to group error:", error);
      } finally {
        this.addLoading = false;
      }
    },

    // 从群组移除用户
    async handleRemoveFromGroup() {
      if (!this.removeForm.groupId) {
        this.$message.warning("请选择群组");
        return;
      }

      this.$confirm("确定要从该群组中移除该用户吗？", "确认操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.removeLoading = true;
        try {
          const data = {
            userId: this.userData.id,
            groupId: this.removeForm.groupId,
            operationType: "REMOVE",
          };

          await manageUserGroup(data);
          this.$message.success("从群组移除用户成功");

          // 重置表单
          this.removeForm.groupId = null;

          // 重新加载用户群组列表
          this.loadUserGroups();
        } catch (error) {
          this.$message.error("从群组移除用户失败");
          console.error("Remove user from group error:", error);
        } finally {
          this.removeLoading = false;
        }
      });
    },

    // 快速移除
    handleQuickRemove(group) {
      this.removeForm.groupId = group.id;
      this.handleRemoveFromGroup();
    },

    // 关闭对话框
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.user-group-manager {
  .user-info-section {
    margin-bottom: 20px;
  }

  .operation-section {
    margin-bottom: 20px;
  }

  .groups-section {
    .el-card {
      margin-top: 20px;
    }
  }
}

.group-selector-inline {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 15px;
  background-color: #fafafa;
  margin-top: 10px;

  .search-section {
    margin-bottom: 15px;
  }

  .pagination-section {
    margin-top: 15px;
    text-align: center;
  }

  .el-table {
    cursor: pointer;
  }
}
</style>
